module.exports = __webpack_public_path__ + "static/media/station-billboard.210372d5.jpg";